/* The original theme product-form owns checkout, cart, properties and tracking.
   This component only synchronizes the product variant, photos, quantity rules
   and the sticky trigger. No remote code or duplicate cart request is added. */
(() => {
  if (customElements.get('woieeo-landing')) return;
  class WoieeoLanding extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.form = this.querySelector('form[data-type="add-to-cart-form"]');
      if (!this.form || !this.variants.length) return;
      this.input = this.form.querySelector('[name="id"]');
      this.quantity = this.querySelector('[name="quantity"]');
      this.buy = this.querySelector('.wl-buy');
      this.submit = this.form.querySelector('[name="add"]');
      this.controls = [...this.querySelectorAll('[data-option-index]')];
      this.mainImage = this.querySelector('.wl-product-photo img');
      this.label = this.submit.querySelector('.main-atc__label__text');
      if (!this.label) {
        const host = this.submit.querySelector('.main-atc__label');
        if (host) { host.textContent = ''; this.label = document.createElement('span'); this.label.className = 'main-atc__label__text'; host.append(this.label); }
      }
      this.originalLabel = this.label ? this.label.textContent : '';
      this.onChange = (event) => {
        if (event.target.closest('[data-option-index]')) this.update(true);
      };
      this.onClick = (event) => {
        const photo = event.target.closest('[data-photo]');
        if (photo) {
          this.selectPhoto([...this.querySelectorAll('[data-photo]')].indexOf(photo));
        }
        if (event.target.closest('[data-gallery-prev]')) this.selectPhoto((this.photoIndex || 0) - 1);
        if (event.target.closest('[data-gallery-next]')) this.selectPhoto((this.photoIndex || 0) + 1);
        const pack = event.target.closest('[data-pick-variant]');
        if (pack) {
          const variant = this.variants.find(item => String(item.id) === pack.dataset.pickVariant);
          if (variant) { this.setOptions(variant.options); this.update(true); }
        }
        const design = event.target.closest('[data-design]');
        if (design) {
          const select = this.querySelector('select[data-option-index="0"]');
          if (select && [...select.options].some(option => option.value === design.dataset.design)) {
            select.value = design.dataset.design;
            this.update(true);
          }
        }
        if (event.target.closest('[data-sticky-submit]') && this.submit && !this.submit.disabled && this.submit.getAttribute('aria-disabled') !== 'true') {
          if (this.form.reportValidity()) this.submit.click();
          else this.form.scrollIntoView({block: 'center', behavior: 'smooth'});
        }
      };
      this.onPopState = () => {
        const id = new URL(location.href).searchParams.get('variant');
        const variant = this.variants.find(item => String(item.id) === id);
        if (variant) { this.setOptions(variant.options); this.update(false); }
      };
      this.onKeyDown = event => {
        if (!event.target.closest('[data-photo]')) return;
        let next;
        if (event.key === 'ArrowRight') next = (this.photoIndex || 0) + 1;
        if (event.key === 'ArrowLeft') next = (this.photoIndex || 0) - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.querySelectorAll('[data-photo]').length - 1;
        if (next !== undefined) { event.preventDefault(); this.selectPhoto(next, true); }
      };
      this.addEventListener('keydown', this.onKeyDown);
      this.addEventListener('change', this.onChange);
      this.addEventListener('click', this.onClick);
      window.addEventListener('popstate', this.onPopState);
      const urlVariant = this.variants.find(item => String(item.id) === new URL(location.href).searchParams.get('variant'));
      const initial = urlVariant || this.variants.find(item => String(item.id) === this.input.value) || this.variants[0];
      this.setOptions(initial.options);
      this.update(false);
      const photos = [...this.querySelectorAll('[data-photo]')];
      const imageKey = src => String(src || '').split('?')[0];
      const photoIndex = photos.findIndex(photo => imageKey(photo.dataset.photo) === imageKey(this.mainImage?.src));
      if (photos.length) this.selectPhoto(photoIndex >= 0 ? photoIndex : 0, false, false);
      this.sticky = this.querySelector('.wl-sticky');
      if (this.sticky && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          this.sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        }, {threshold: 0});
        this.observer.observe(this.querySelector('.wl-offer'));
      }
    }
    disconnectedCallback() {
      this.removeEventListener('keydown', this.onKeyDown);
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('popstate', this.onPopState);
      this.observer?.disconnect();
      this.initialized = false;
    }
    options() {
      return this.controls.map(control => control.tagName === 'SELECT' ? control.value : control.querySelector('input:checked')?.value);
    }
    setOptions(values) {
      this.controls.forEach(control => {
        const index = Number(control.dataset.optionIndex);
        if (control.tagName === 'SELECT') control.value = values[index];
        else control.querySelectorAll('input').forEach(input => { input.checked = input.value === values[index]; });
      });
    }
    update(changeUrl) {
      let options = this.options();
      let variant = this.variants.find(item => item.options.every((value, index) => value === options[index]));
      // Some styles expose fewer pack options. Select a valid pack for that style.
      if (!variant && options.length) {
        variant = this.variants.find(item => item.options[0] === options[0] && item.available) || this.variants.find(item => item.options[0] === options[0]);
        if (variant) { this.setOptions(variant.options); options = variant.options; }
      }
      const available = Boolean(variant?.available);
      this.currentVariant = variant;
      this.input.value = variant ? String(variant.id) : '';
      this.input.disabled = !variant;
      this.submit.disabled = !available;
      this.submit.setAttribute('aria-disabled', String(!available));
      if (this.label) this.label.textContent = available ? this.dataset.atc : this.dataset.soldOut;
      this.buy.dataset.unavailable = String(!available);
      const warning = this.querySelector('[data-variant-warning]');
      warning.hidden = available;
      warning.textContent = available ? '' : this.dataset.unavailable;
      this.querySelector('[data-price]').textContent = variant ? this.plainMoney(variant.money) : '—';
      const compare = this.querySelector('[data-compare]');
      compare.hidden = !(variant && variant.compare_at_price > variant.price);
      compare.textContent = variant ? this.plainMoney(variant.compare_money) : '';
      this.controls.forEach(control => {
        const index = Number(control.dataset.optionIndex);
        if (control.tagName === 'SELECT') return;
        control.querySelectorAll('input').forEach(input => {
          const match = this.variants.find(item => item.options.every((value, i) => value === (i === index ? input.value : options[i])));
          input.disabled = !match || !match.available;
          const price = input.closest('.wl-pack').querySelector('[data-pack-price]');
          price.textContent = match ? this.plainMoney(match.money) : '—';
          const unit = input.closest('.wl-pack').querySelector('[data-pack-unit]');
          const count = Number((input.value.match(/\d+/)||[])[0]);
          if (unit) unit.textContent = match && options.length === 1 && count > 0 ? this.formatUnit(match.price / count, match.money) + ' ' + this.dataset.unitLabel : '';
        });
      });
      if (variant) {
        const min = variant.min || 1;
        const step = variant.increment || 1;
        this.quantity.min = String(min);
        this.quantity.step = String(step);
        if (variant.max) this.quantity.max = String(variant.max);
        else this.quantity.removeAttribute('max');
        const value = Number(this.quantity.value);
        if (!Number.isFinite(value) || value < min || (value - min) % step || (variant.max && value > variant.max)) this.quantity.value = String(min);
        const stickyPrice = this.querySelector('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = this.plainMoney(variant.money);
        const stickyVariant = this.querySelector('[data-sticky-variant]');
        if (stickyVariant) stickyVariant.textContent = variant.options.join(' / ');
        if (variant.image) this.showImage(variant.image, variant.options.join(' / '));
        if (changeUrl) {
          const url = new URL(location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString()); // Retains UTM and other query parameters.
        }
      }
      const stickyButton = this.querySelector('[data-sticky-submit]');
      if (stickyButton) stickyButton.disabled = !available;
      this.input.dispatchEvent(new Event('change', {bubbles: true}));
      this.dispatchEvent(new CustomEvent('woieeo:variant-change', {bubbles: true, detail: {variant}}));
    }
    formatUnit(cents, money) {
      const plain = this.plainMoney(money);
      // Keep Shopify's current currency decoration; replace only its amount.
      const amount = (cents / 100).toFixed(2);
      return plain.replace(/[\d.,]+/, amount);
    }
    plainMoney(html) {
      const template = document.createElement('template');
      template.innerHTML = html || '';
      return template.content.textContent;
    }
    selectPhoto(index, focus = false, reveal = true) {
      const photos = [...this.querySelectorAll('[data-photo]')];
      if (!photos.length) return;
      this.photoIndex = (index % photos.length + photos.length) % photos.length;
      const photo = photos[this.photoIndex];
      this.showImage(photo.dataset.photo, photo.dataset.alt);
      if (focus) photo.focus({preventScroll: true});
      if (reveal) photo.scrollIntoView?.({block: 'nearest', inline: 'nearest', behavior: 'smooth'});
    }
    showImage(src, alt) {
      if (!this.mainImage) return;
      this.mainImage.removeAttribute('srcset');
      this.mainImage.src = src;
      this.mainImage.alt = alt || '';
      const photos = [...this.querySelectorAll('[data-photo]')];
      const imageKey = value => String(value || '').split('?')[0];
      const found = photos.findIndex(photo => imageKey(photo.dataset.photo) === imageKey(src));
      photos.forEach((photo, index) => photo.setAttribute('aria-pressed', String(index === found)));
      if (found >= 0) this.photoIndex = found;
      const counter = this.querySelector('[data-gallery-count]');
      if (counter) counter.textContent = found >= 0 ? `${found + 1} / ${photos.length}` : `— / ${photos.length}`;
    }
  }
  customElements.define('woieeo-landing', WoieeoLanding);
})();
